import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  Center,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const EmailSentPage = () => {
  const navigate = useNavigate();

  return (
    <Flex>
      <Box flex={1} bg={"black"}>
        <Center height={"100vh"}>
          <Flex
            alignItems={"center"}
            direction={"column"}
            bg={"grey.400"}
            w={"462px"}
            padding={4}
          >
            <Image
              src={require("../../../assets/logo.svg").default}
              w={88}
              h={76}
            />
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              KIDSWEAR
            </Text>
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              COLLECTIVE
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBlock={8}
            >
              Business Team
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBottom={"16px"}
            >
              PASSWORD RESET LINK SENT
            </Text>

            <Box mb={4} w={"100%"}>
              <Text
                color={"#FFFFFF"}
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"12px"}
                marginBottom={"8px"}
              >
                A password reset link has been sent to your email
              </Text>
            </Box>
            <Button
              onClick={() => navigate("/")}
              w={"100%"}
              borderRadius={8}
              bg={"primary.500"}
              color={"#FFFFFF"}
              fontSize={14}
              fontFamily={"PlusJakartaSansMedium"}
              textTransform={"uppercase"}
              _hover={{
                bg: "#273979",
                color: "#737373",
              }}
            >
              Confirm
            </Button>
          </Flex>
        </Center>
      </Box>
    </Flex>
  );
};

export default EmailSentPage;
